import { render, staticRenderFns } from "./GuestRegisterAlert.vue?vue&type=template&id=0a9f2d5a&scoped=true&"
import script from "./GuestRegisterAlert.vue?vue&type=script&lang=ts&"
export * from "./GuestRegisterAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9f2d5a",
  null
  
)

export default component.exports